<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-sticky tw-top-0 tw-z-10">
            <div class="tw-mx-auto tw-px-6 tw-py-4 tw-flex tw-justify-between tw-items-center">
                <div>
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-2xl tw-font-bold">Leituras Automáticas</h1>
                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-sm tw-mt-1">Por padrão, o sistema realiza duas leituras diárias, uma às 4h e outra às 16h</p>
                </div>
                <div class="tw-flex tw-items-center tw-gap-4">
                    <span v-if="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400 tw-border-amber-500/20' : 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200'" class="tw-px-4 tw-py-1.5 tw-rounded-full tw-border">
                        Modo Visualização
                    </span>
                </div>
            </div>
        </div>

        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-min-h-screen tw-mx-auto tw-p-6">
            <div class="tw-max-w-2xl tw-mx-auto">
                <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-6 tw-shadow-sm">
                    <div class="tw-flex tw-items-center tw-gap-3 tw-mb-8">
                        <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-emerald-500/10 tw-text-emerald-400' : 'tw-bg-emerald-50 tw-text-emerald-600'">
                            <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                        </div>
                        <div>
                            <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Gerenciar Horários</h3>
                        </div>
                    </div>

                    <div class="tw-space-y-4">
                        <div class="tw-space-y-3">
                            <div v-if="horarios.length === 0" :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-text-slate-400' : 'tw-bg-slate-50 tw-text-slate-500'" class="tw-p-6 tw-rounded-xl tw-text-center tw-text-sm">
                                Nenhum horário configurado
                            </div>
                            <div v-for="horario in horarios" :key="horario.id" :class="theme === 'dark' ? 'tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-[#1a1d21] tw-rounded-xl hover:tw-bg-slate-800/70' : 'tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-slate-50 tw-rounded-xl hover:tw-bg-slate-100'">
                                <div class="tw-flex tw-items-center tw-gap-4">
                                    <span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-font-medium">{{ horario.horario.substring(0, 5) }}</span>
                                </div>
                                <button 
                                    @click="removerHorario(horario.id)" 
                                    :disabled="!permissaoEditar"
                                    :class="theme === 'dark' ? 'hover:tw-bg-red-500/20 tw-text-red-400 disabled:tw-opacity-50' : 'hover:tw-bg-red-100 tw-text-red-600 disabled:tw-opacity-50'"
                                    class="tw-p-2 tw-rounded-lg disabled:tw-cursor-not-allowed"
                                >
                                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                                </button>
                            </div>
                        </div>

                        <hr class="tw-my-6" />

                        <div class="tw-space-y-4">
                            <h4 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-bold tw-uppercase tw-tracking-wider">Adicionar novo horário</h4>
                            <div class="tw-flex tw-gap-3">
                                <input 
                                    type="time" 
                                    v-model="novoHorario" 
                                    :disabled="!permissaoEditar"
                                    :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-300 tw-text-black'"
                                    class="tw-flex-1 tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-emerald-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                >
                                <button 
                                    @click="adicionarHorario()"
                                    :disabled="!permissaoEditar"
                                    :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-300 tw-text-slate-700 hover:tw-bg-gray-300'"
                                    class="tw-px-6 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                                >
                                    Adicionar
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <div v-if="permissaoEditar" class="tw-flex tw-gap-3 tw-justify-end tw-mt-6">
                    <button 
                        @click="resetHorarios"
                        :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-200 tw-text-slate-700 hover:tw-bg-gray-300'"
                        class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl"
                    >
                        Descartar
                    </button>
                    <button 
                        @click="salvarHorarios"
                        :disabled="salvandoLoading"
                        :class="theme === 'dark' ? 'tw-bg-emerald-500 hover:tw-bg-emerald-600 focus:tw-ring-emerald-500/20' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-100'"
                        class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50"
                    >
                        <span v-if="!salvandoLoading">Salvar Horários</span>
                        <span v-else>Processando...</span>
                    </button>
                </div>
            </div>
        </main>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import { mapState } from 'vuex';

export default {
    components: {
        MainLayout,
        LoaderPage
    },

    setup() {
        const store = useStore();
        const toast = useToast();
        const loadingPage = ref(true);
        const route = useRoute();
        const horarios = ref([]);
        const horariosBackup = ref([]);
        const novoHorario = ref('');
        const permissaoEditar = ref(false);
        const salvandoLoading = ref(false);

        onMounted(async () => {
            loadingPage.value = true;
            const unidadeId = route.params.unidade;
            permissaoEditar.value = store.state.unidade.unidade.permissoes?.alteracao_leitura_automatica || false;

            try {
                const response = await store.dispatch("leituras/getLeiturasAutomaticas", unidadeId);
                horarios.value = response;
                horariosBackup.value = structuredClone(response);

            } catch (error) {
                console.error("Erro ao buscar leituras:", error);
                toast.error("Erro ao buscar leituras");
            }
            loadingPage.value = false;
        });

        const removerHorario = async (horarioId) => {
            horarios.value = horarios.value.filter(horario => horario.id !== horarioId);
            toast.info("Horário removido, clique em SALVAR para manter as alterações");
        };

        const adicionarHorario = async () => {
            if (!novoHorario.value) {
                toast.error("Por favor, insira um horário válido");
                return;
            }

            try {
                horarios.value.push({
                    id: Date.now(),
                    unidade_id: route.params.unidade,
                    horario: novoHorario.value + ":00",
                    status: 1,
                    created_at: new Date().toISOString(),
                    updated_at: new Date().toISOString()
                });
                novoHorario.value = '';
                toast.info("Horário adicionado, clique em SALVAR para manter as alterações");
            } catch (error) {
                console.error("Erro ao adicionar horário:", error);
                toast.error("Erro ao adicionar horário");
            }
        };

        const resetHorarios = () => {
            horarios.value = structuredClone(horariosBackup.value);
            toast.info("Alterações canceladas");
        };

        const salvarHorarios = async () => {
            salvandoLoading.value = true;
            const horariosASalvar = horarios.value.map(horario => ({
                horario: horario.horario.substring(0, 5),
                status: horario.status
            }));
            try {
                const unidadeId = route.params.unidade;
                let response = await store.dispatch("leituras/salvarLeiturasAutomaticas", { unidadeId, horariosASalvar });
                toast.info("Dados enviados ao Painel TermoWeb, aguardando confirmação...", { timeout: 3900 });
                horariosBackup.value = structuredClone(horarios.value);
                let messageId = response.data.message.message_id;
                setTimeout(async () => {
                    let msg = await store.dispatch("message/fetchMessage", messageId);
                    if (msg.status != 'processed') {
                        toast.error("Atualização nos horários não processada pelo Painel TermoWeb.");
                    } else {
                        toast.success("Horários atualizados com sucesso.");
                    }
                }, 4000);
            } catch (error) {
                console.error("Erro ao salvar horários:", error);
                toast.error("Erro ao salvar horários");
            }
            salvandoLoading.value = false;
        };

        return {
            loadingPage,
            horarios,
            novoHorario,
            removerHorario,
            adicionarHorario,
            permissaoEditar,
            resetHorarios,
            salvarHorarios,
            salvandoLoading
        }
    },

    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
    }
}
</script>